import React, { useState } from "react";
import "./HealthcareChoose.css";
import img1 from "../healthcareassets/consult1.jpg";
import img2 from "../healthcareassets/consult2.png";
import img3 from "../healthcareassets/consult3.jpg";
import img4 from "../healthcareassets/consult4.jpg";

const cards = [
  {
    img: img1,
    title: "Profound Technology Expertise",
    desc: "Migrate confidently with AWS-certified experts who design cloud roadmaps that minimize downtime, optimize resources, and accelerate ROI through a proven, secure consulting approach.",
  },
  {
    img: img2,
    title: "Innovation at the Core",
    desc: "Unlock flexibility with hybrid and multi-cloud strategies. We orchestrate workloads across AWS, Azure, and GCP to enhance performance, scalability, resilience, and operational efficiency.",
  },
  {
    img: img3,
    title: "Regulatory Compliance",
    desc: "Protect your business from disruptions with cloud-native backup and disaster recovery solutions that ensure data integrity, compliance, and continuous operations.",
  },
  {
    img: img4,
    title: "Proven Track Record",
    desc: "Adopt Kubernetes the right way. From cluster design to workload optimization, we help enterprises achieve scalable, secure, production-grade deployments.",
  },
];

export default function HealthcareChoose() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % cards.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + cards.length) % cards.length);
  };

const slidesCount = Math.ceil(cards.length / 2);

  return (
    <section id="healthcare-choose" className="cloudmainclass">
      <div className="cloud-header">
        <h2 className="heading">
       Why Choose BastionEx as Your Healthcare IT Consulting Partner?
        </h2>
        <p className="subheading">
         We deliver innovative, high-quality healthcare IT consulting services that drive measurable improvements and lasting impact across the healthcare ecosystem.
        </p>
      </div>

      <div className="cloud-cards cloud-cards-desktop">
        {cards.map((card, index) => (
          <div className="cloud-card" key={index}>
            <div className="card-image">
              <img src={card.img} alt={card.title} />
            </div>
            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="cloud-carousel-mobile">
        <button onClick={prevSlide} className="carousel-button carousel-prev">
          &#8249;
        </button>

        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card, index) => (
              <div className="carousel-slide" key={index}>
                <div className="cloud-card">
                  <div className="card-image">
                    <img src={card.img} alt={card.title} />
                  </div>
                  <div className="card-content">
                    <h3>{card.title}</h3>
                    <p>{card.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button onClick={nextSlide} className="carousel-button carousel-next">
          &#8250;
        </button>
      </div>

 <div className="carousel-dots">
  {Array.from({ length: slidesCount }).map((_, index) => (
    <button
      key={index}
      onClick={() => setCurrentSlide(index)}
      className={`carousel-dot ${currentSlide === index ? "active" : ""}`}
    />
  ))}
</div>


    </section>
  );
}
